module.exports = __webpack_public_path__ + "img/sarit_cover.12e1f9b5.jpg";